export const formatLastSeen = (isoString: string | null | undefined): string => {
  // Handle null/undefined cases
  if (!isoString) return "Unknown";
  
  try {
    const date = new Date(isoString);
    
    // Check if the date is valid
    if (isNaN(date.getTime())) {
      console.warn("Invalid date string:", isoString);
      return "Unknown";
    }

    const now = new Date();
    const diffInHours = Math.abs(now.getTime() - date.getTime()) / (1000 * 60 * 60);

    if (diffInHours < 24) {
      // Today - show time only
      return new Intl.DateTimeFormat(navigator.language, {
        hour: '2-digit',
        minute: '2-digit'
      }).format(date);
    } else if (diffInHours < 48) {
      // Yesterday
      return 'Yesterday';
    } else if (diffInHours < 168) {
      // Within 7 days - show weekday
      return new Intl.DateTimeFormat(navigator.language, {
        weekday: 'short'
      }).format(date);
    } else {
      // Older than 7 days - show date
      return new Intl.DateTimeFormat(navigator.language, {
        month: 'short',
        day: 'numeric'
      }).format(date);
    }
  } catch (error) {
    console.error("Error formatting last seen date:", error);
    return "Unknown";
  }
};